/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule, PaginatorModule,InputSwitchModule, DropdownModule, TreeNode,SpinnerModule,ConfirmDialogModule,ConfirmationService, ListboxModule} from 'primeng/primeng';
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import {FormsModule, FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from "@angular/platform-browser";
import {MamAdminService} from '../../service/mam_service.component';
import { MdmPolicyCondition } from '../../model/mdmpcond';
import { MdmPolicyControl } from '../../model/mdmpolicycontrol';
import { MdmPolicyTarget } from '../../model/mdmptgtmdl';
import { MdmPolicy } from '../../model/mdmpolicy';
import { MDMPCONTCLS } from '../../model/mdmpolicycontrolclass';
import { AppPlatform } from '../../model/enumModel';
import {SelectItem} from "primeng/components/common/api";
import {CheckboxModule} from "primeng/components/checkbox/checkbox";
import {ExDialogModule} from "../../component/dialog.component";
import {UserGroupCheckTreeModule} from "../../component/user_checktree.component";
import { Device } from '../../model/device';
import {TargetUserModule} from "../../component/target_user.component";
import {TargetDeviceModule} from "../../component/target_device.component";
import {CommonModule} from "@angular/common";
import {TargetGroupModule} from "../../component/target_group.component";
import {ANGULAR2_COOKIE_PROVIDERS} from "angular2-cookie/core";
import {TranslateServiceForm} from "../../translate/translate.service";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS

@Component({
  selector: 'policy-config',
  templateUrl: './policy_config_new.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls : ['./policy_config_new.css']

})
export class PolicyConfigNewComponent implements OnInit {

  private mdmpcondList : MdmPolicyCondition[] = [];
  private mdm_policy_control_list : MdmPolicyControl[] = [];
  private mdm_policy_control_default_list : MdmPolicyControl[] = [];
  private mdm_policy_target_model_list : MdmPolicyTarget[] = [];
  private mdm_policy_control_classList : MDMPCONTCLS[] = [];
  private mdm_policy_model_list : MdmPolicy[] = [];
  private device_list : Device[] = [];

  mdmPolicy : MdmPolicy;

  totalRecord : number;
  targetList : any;
  tabDeviceTabNumber : number = 0;

  platform  : string="ANY";
  category : any = "4000";
  selectedPolicyItem : Object[];
  selectedPolicyLists : any[] =[];

  selectItem : SelectItem[];


  conditionAllSelected : any;
  detailShow : boolean;
  detailName : string;
  detailSettingValue : string;
  title : string;
  dialogWidth :string;


  // Tree Node
  policyList : TreeNode[] = [];
  p_node : TreeNode;
  policyAddShow : boolean=false;
  policyAddForm : FormGroup;
  companyLists : SelectItem[]=[];

  policyType_items : SelectItem[]=[];

  policyDetailSelected : any[]=[];
  beforeTotalPolicyDetailSelected : any[] = [];
  afterTotalPolicyDetailSelected : any[]=[];
  policyDetailClassList : any[]=[];
  options : SelectItem[] = [];
  selectedCondtion : any;

  targetAddShow : boolean = false;
  selectdTargetLists : any;
  @ViewChild('tAny') tAny : any;
  @ViewChild('any') anyTab:any;
  @ViewChild('android') androidTab:any;
  @ViewChild('ios') iosTab:any;
  @ViewChild('windowsMobile') windowsMobileTab:any;
  @ViewChild('windowsOs') windowsOsTab:any;
  @ViewChild('osTab') osTab:any;

  @ViewChild('targetTab') targetTab:any;
  selectedPolicy : any;
  priority : any;
  pageMax : number;

  policyConditionListAddShow : boolean = false;
  pConList : SelectItem[];
  pConListAddVal : any ="time";
  conditonAddName : string;
  selectedHoliday : string[] = [];
  beginHH : number = 9;
  beginMM : number = 0;
  endHH : number = 18;
  endMM : number = 0;
  officeAppList : any;
  selectedOfficeAppList : any;

  selectedGroupList : any;
  selectedUserList : any;
  selectedDeviceList : any;
  setGroupTargetList : TreeNode[];
  setUserTargetList : any;
  setDeviceTargetList : any;
  getPolicyTargetLists : any;
  delTargets: any[]=[];
  delTargetIdx: any[] =[];

  areaTypeShow :boolean = false;
  viewTypeTargett : any= "group";
  groupShow : boolean = false;

  selected_policyType_item : any;

  targetTitle : any;
  areaType_items : SelectItem[] = [];
  selectedCompany : any;

  control_gps_list : any;
  selectedGPSList : any= [];
  ngOnInit() {
    /*this.getPolicyTarget('1',1,9999);
    this.getPolicyConditionList(1,1,10);
    this.getPolicyControlList(1,1,10);*/
    //
    // //id는 condition id.
    // this.getPolicyControlDefault(1);
    //
    //this.getPolicyOne(1);
    //this.getDeviceByUser(25, 1, 10);

  }

  private translate:TranslateServiceForm;

  constructor(private service : MamAdminService, private fb: FormBuilder, private confirmationService: ConfirmationService, private _translate: TranslateServiceForm, private logger : Logger) {
    this.translate = _translate;
    this.pConList = [];
    this.pConList.push({label : 'Time '+this.translate.instant('LANG_POLICY_CONDITION'),value : 'time'});
    this.pConList.push({label : 'Wifi-AP '+this.translate.instant('LANG_POLICY_CONDITION'),value : 'wifi'});
    this.pConList.push({label : this.translate.instant('LANG_POLICY_CONDITION_LOCATION')+" "+this.translate.instant('LANG_POLICY_CONDITION'),value : 'location'});
    this.pConList.push({label : 'GPS'+this.translate.instant('LANG_POLICY_CONDITION'),value : 'gps'});
    this.pConList.push({label : this.translate.instant('LANG_Office_App')+this.translate.instant('LANG_POLICY_CONDITION'),value : 'officeApp'});

    this.policyType_items.push({label : '-------',value : null});
    this.policyType_items.push({label : this.translate.instant('LANG_Noraml2'),value : 0});
    /*this.policyType_items.push({label : '출입',value : 1});*/
    this.policyType_items.push({label : 'QR',value : 2});
    /*this.policyType_items.push({label : 'Windows',value : 3});*/
    this.selected_policyType_item = this.policyType_items[0];

    this.areaType_items.push({label : 'IN',value : 0});
    this.areaType_items.push({label : 'OUT',value : 1});


    this.policyAddForm = this.fb.group({
      'name' : new FormControl('',Validators.required),
      'company' : new FormControl('',Validators.required),
      'type' : new FormControl(null,Validators.required),
      'areaType'   : new FormControl(''),
      'policyDesc' : new FormControl(''),
      'baseFlag' : new FormControl('false')
    });

    this.targetTitle = this.translate.instant('BUTTON_OK2');
  }

  //-----------------------------------Service------------------------------
  getPolicyConditionList(policyId:number, page:number, max:number) {
    this.service.getPolicyConditionList(policyId, page, max).subscribe(
        value => {
          this.mdmpcondList = value.rows;
          //this.selectedCondtion = "";
          if(this.mdmpcondList && this.mdmpcondList.length>0){
            this.mdmpcondList.forEach(item =>{
              if(item.name == "ANY"){
                this.selectedCondtion = item;
              }
            })
          }

          this.logger.debug("mdm_policy_condition_list : ", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
          this.policyDetailClassList = [];
          this.policyDetailSelected = [];
          this.getPolicyControlDefault(this.selectedCondtion.id);  // 누를때 데이터 정책항목 가져오기
        }
      )
  }

  getPolicyTarget(policyId:string, page:number, max:number) {
    this.service.getPolicyTarget(policyId, page, max).subscribe(
        value => {
          this.mdm_policy_target_model_list = value.rows;
          this.targetList = value.rows;
          //this.totalRecord = value.total;
          let userIdx =[];
          let deviceIdx = [];
          this.targetList.forEach(item => {
            if(item.targetType == "U"){
              userIdx.push(item.targetId);
            }else if(item.targetType == "D"){
              deviceIdx.push(item.targetId);
            }
          })

          this.logger.debug("userIdx",userIdx.join("|"));
          this.logger.debug("deviceIdx",deviceIdx.join("|"));

          if(userIdx && userIdx.length > 0) this.getUserByIdx(userIdx.join("|"));
          if(deviceIdx && deviceIdx.length>0) this.getDeviceByIdx(deviceIdx.join("|"));
          this.logger.debug("mdm_policy_target_model_list : ", value);

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getPolicyTargetList(policyId: number,type : string, page?:number, size?:number ){
    this.service.getPolicyTargetList(policyId, type, page, size).subscribe(
      value => {
        this.logger.debug("getPolicyTargetLists : ", value);
        if(type=="group") {
          let notTypeOnlyValue = [];
          //console.debug("자 그룹은 ",value);
          if(value && value.length>0){
            for(let item of value){
              if(item.type != "TYPE") {notTypeOnlyValue.push(item);}
            }
          }
          //console.debug("그룹에서 value만 남았을때 ",notTypeOnlyValue);
          this.setGroupTargetList = notTypeOnlyValue;
          this.getPolicyTargetLists = notTypeOnlyValue;
        }
        else if(type=="user") {this.setUserTargetList = value.content; this.getPolicyTargetLists = value.content;}
        else if(type=="device") {this.setDeviceTargetList = value.content; this.getPolicyTargetLists = value.content;}

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  getPolicyControlDefault(conditionListId:number) {
    this.service.getPolicyControlDefault(conditionListId).subscribe(
        value => {
          this.logger.debug("getPolicyControlDefault : ",value);
          this.mdm_policy_control_default_list = value.default;


          this.conditionAllSelected = value.select;
          this.logger.debug("mdm_policy_control_default_list : ", value);

          this.mdm_policy_control_default_list.forEach(item => {
            item.name = this.translate.instant("MdmPolicyControlName_" + item.name);
            item.controlValue = item.itemDefaultValue;
            this.conditionAllSelected.forEach(val =>{

              if(item.id == val.controlClass.id){
                  if(val.controlValue.toUpperCase() == "TRUE"){
                    item.controlValue = true;
                  }else if(val.controlValue.toUpperCase() == "FALSE"){
                    item.controlValue = false;
                  }else{
                    item.controlValue = val.controlValue;
                    this.logger.debug(item.controlValue);
                  }
                  this.policyDetailSelected.push(item);
              }
              this.beforeTotalPolicyDetailSelected=[];
              this.afterTotalPolicyDetailSelected=[];
              this.beforeTotalPolicyDetailSelected = Object.assign([],this.policyDetailSelected);
              this.afterTotalPolicyDetailSelected = this.policyDetailSelected;
            });

            if(item.controlValue == "TRUE"){
              item.controlValue = true;
            }else if(item.controlValue == "FALSE"){
              item.controlValue = false;
            }


            if(item.valueType.indexOf("&") != -1){
              this.options = this.getSelect(item.valueType);
              item.options = this.options;
            }

            if(item.category=="4000" && item.platform=="ANY"){
              this.policyDetailClassList.push(item);
            }
          });
          this.logger.debug("policyDetailClassList",this.policyDetailClassList);

        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  saveToDeploy(pId:number, pTarget:any) {
    this.service.saveToDeploy(pId, pTarget).subscribe(
        value => {
          let result = value;
          if(result == 0){
            alert(this.translate.instant('MESSAGE_Success_Ok'));
            //this.getNewPolicyTree(this.selectedCompany.id,0,"default");
          }else{
            alert(this.translate.instant('MESSAGE_Success_Fail'));
          }

          this.logger.debug("save To Deploy :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  /*getGroupUserList(groupId: number,page: number,size : number){
    this.service.getGroupUserList(groupId,page,size).subscribe(
      value => {
        let tempLis : any;
        tempLis = value;
        this.targetUserList = value.content;
        this.totalRecord = value.totalElements;
        this.logger.debug("-- tempLis :", tempLis);
      },error => {
        this.logger.error("-- error : " + error);
      },() => {

      }
    )
  }*/

  insertPolicyCondition(policyId : number, params : any){
    this.service.insertPolicyCondition(policyId,params).subscribe(
      value => {
        if(value){
          alert(this.translate.instant('MESSAGE_PolicyCondition_Add'));
          this.getPolicyConditionList(this.selectedPolicy.id, 1, 10);
        }
        this.logger.debug("value", value);
      },error => {
        this.logger.error("-- error : " + error);
      },() => {

      }
    )
  }

  deletePolicyCondition(id:number){
    this.service.deletePolicyCondition(id).subscribe(
      value => {
        if(value){
          alert(this.translate.instant('Operation_DELETE'));
          this.getPolicyConditionList(this.selectedPolicy.id, 1, 10);
        }
        this.logger.debug("value", value);
      },error => {
        this.logger.error("-- error : " + error);
      },() => {

      }
    )
  }

  getGroupTarget(policyId :number){
    this.service.getGroupTarget(policyId).subscribe(
      value => {
        this.logger.debug("-- get Group Targetvalue : " , value);
        this.setGroupTargetList = value;
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  deletePolicyTarget(targetIdx : string,viewTypeTargett : string){
    this.service.deletePolicyTarget(targetIdx,viewTypeTargett).subscribe(
      value => {
        this.logger.debug("-- delete Targetvalue : " , value);
        if(value == 1 || value.result=="Ok"){
          alert(this.translate.instant('Operation_DELETE'));
        }
        if(viewTypeTargett == "group") this.getPolicyTargetList(this.selectedPolicy.id,viewTypeTargett);
        else this.getPolicyTargetList(this.selectedPolicy.id,viewTypeTargett,0,400);
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  getDeviceByIdx(idx:string) {
    this.service.getDeviceByIdx(idx).subscribe(
      value => {
        this.setDeviceTargetList = value;
        this.logger.debug("-- getDeviceByIdx  : " , value);
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  getUserByIdx(idx:string){
    this.service.getUserListByIdx(idx).subscribe(
      value => {
        this.setUserTargetList = value;
        this.logger.debug("-- getUserByIdx : " , value);
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  addTargetList(policyId : number, type : string , params : any){
    this.service.addTargetList(policyId,type,params).subscribe(
      value => {
        this.logger.debug("-- addTargetList : " , value);
        if( this.viewTypeTargett == "group") { this.getPolicyTargetList(this.selectedPolicy.id,"group"); this.delTargets = [];}
        else if( this.viewTypeTargett == "user") { this.getPolicyTargetList(this.selectedPolicy.id,"user",0,400); this.delTargets = [];}
        else if( this.viewTypeTargett == "device")  { this.getPolicyTargetList(this.selectedPolicy.id,"device",0,400); this.delTargets = [];}

        alert(this.translate.instant('MESSAGE_Target_Add_Ok'));
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  deployPolicyTarget(policyId : number,type :string, list: any){
    this.service.deployPolicyTarget(policyId,type,list).subscribe(
      value => {
        this.logger.debug("-- deployPolicyTarget 한 결과값: " , value);
        if(value == 'deploy result URL'){
          alert(this.translate.instant('MESSAGE_Distribution_Ok'));
        }
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  getNewPolicyTree(companyId:number,type:number,diff:string){
    this.service.getNewPolicyTree(companyId,type,diff).subscribe(value =>{
        this.policyList = [];
        let item = value;
        if(item && item.length>0){
          item.forEach(val => {
            this.policyList.push({label:val.name,data:val});
          })
        }

      },
      error =>{this.logger.debug("error",error)});
  }

  getOfficeAppList(companyId:number){
    this.service.getOfficeAppList(companyId).subscribe(
        value=>{
          this.logger.debug("officeAppList값 : ",value);
          this.officeAppList = value;
          /*if(value && value.length >0){
            value.forEach(item => {
              this.officeAppList.push({label: item.name +"("+item.binaryFilePath+")"+ " > " + item.packageName , value:item});
            });
          }*/
        },
        error =>{this.logger.debug("error",error)});
  }

  //-------------------------------event -------------------------------------------

  onPolicyConditionListSelect(event){
    this.logger.debug(" onPolicyConditionListSelect : ", event.data.id);

    this.policyDetailClassList = [];
    this.policyDetailSelected = [];
    this.getPolicyControlDefault(event.data.id);
    let tabArr = this.anyTab.tabs;
    for(let i=0;i<tabArr.length;i++){
      if(i==0){tabArr[i].selected=true;}
      else{tabArr[i].selected=false;}
    }
    let osArr = this.osTab.tabs;
    for(let i=0;i<osArr.length;i++){
      if(i==0){osArr[i].selected=true;}
      else{osArr[i].selected=false;}
    }

  }

  jungbokSearch(list) {
    for (let i = 0; i < this.policyDetailSelected.length; i++) {
      if (this.policyDetailSelected[i].id == list.id) {
        this.policyDetailSelected.splice(i, 1);
      }
    }
  }

  dropdownChanging(event,list){

    this.jungbokSearch(list);
    this.policyDetailSelected.push(list);
  }

  textChanging(event,list){

    this.jungbokSearch(list);
    this.policyDetailSelected.push(list);
  }
  switchChanging(event,list){

    this.jungbokSearch(list);
    this.policyDetailSelected.push(list);
  }

  /*paginate(event) {

      this.getPolicyTarget("1",event.page + 1, event.rows);
  }*/

  getSearchFlatformAndCategory(category : string, platform : string){
      this.policyDetailClassList = [];
      this.mdm_policy_control_default_list.forEach(item =>
      {
        if(item.category == category && item.platform == platform){
          this.policyDetailClassList.push(item);
        }
      })
  }

  onTabDeviceType(event){
    this.tabDeviceTabNumber = event.index;
    this.policyDetailClassList = [];
    if(this.tabDeviceTabNumber == 0){
      this.platform = "ANY";

      let tabArr = this.anyTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("4000", this.platform);

    }else if(this.tabDeviceTabNumber == 1){
      this.platform = "ANDROID";
      let tabArr = this.androidTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("2000", this.platform);

    }else if(this.tabDeviceTabNumber == 2){
      this.platform = "IOS";
      let tabArr = this.iosTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("3001", this.platform);
    }else if(this.tabDeviceTabNumber == 3){
      this.platform = "WINDOWS_PHONE";
      let tabArr = this.windowsMobileTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("5000", this.platform);
    }else if(this.tabDeviceTabNumber == 4){
      this.platform = "WINDOWS_OS";
      let tabArr = this.windowsOsTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }

      this.getSearchFlatformAndCategory("6000", this.platform);
    }

  }

  onTableHeaderCheckboxToggle(event){
    this.logger.debug("onHeaderToggle event : ",event);
    let temp = this.policyDetailSelected;
    let ttt = this.afterTotalPolicyDetailSelected;
    this.logger.debug("눌렀을때 바뀐거",this.policyDetailSelected);
    this.logger.debug(" 전에 만들어놓은거 totalPolicyDetailSelectedddddd",this.afterTotalPolicyDetailSelected);


    if (event.checked === true) {
      if(ttt && ttt.length>0){
        ttt.forEach((item,index)=>{
          temp.forEach(val =>{
            if(val.id == item.id){
              ttt.splice(index,1);
            }
          })
        });
        temp.forEach(val => {
          ttt.push(val);
        });

      this.logger.debug("예전 최종 ", this.beforeTotalPolicyDetailSelected);
      this.logger.debug("최종 선택된거",this.afterTotalPolicyDetailSelected);

      this.policyDetailSelected = this.afterTotalPolicyDetailSelected;
      }else{
        //아무것도 없을때 처리..
        this.policyDetailSelected = this.beforeTotalPolicyDetailSelected;
      }

    }else{
      this.logger.debug("변경 x");
      this.policyDetailSelected = this.beforeTotalPolicyDetailSelected;
    }
  }

  /*totalSelected(){
    if(this.totalPolicyDetailSelected){
      if(this.policyDetailSelected && this.policyDetailSelected.length > 0){

        this.policyDetailSelected.forEach((item) => {
          this.totalPolicyDetailSelected.forEach((total,index) => {
            if(item.id==total.id)
              this.totalPolicyDetailSelected.splice(index,1);
          })
        })
      }
      this.policyDetailSelected.forEach(item => {
        this.totalPolicyDetailSelected.push(item);
      })
    }
    this.logger.debug("토탈",this.totalPolicyDetailSelected);

  }*/

  anySelectCategory(event){
    this.category="400"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  androidSelectCategory(event){
    this.category = "200"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  iosSelectCategory(event){
    this.category = "300"+(event.index+1);
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  windowsMobileSelectCategory(event){
    this.category = "500"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  windowsOSSelectCategory(event){
    this.category = "600"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }

  policyTargetAdd(){
    if(this.selectedPolicy){

      this.targetAddShow = true;
      this.title = this.translate.instant('LANG_policyTargetTitle');
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }


  }
  policyTargetDel(){
    this.delTargetIdx = [];
    this.delTargets.forEach(item => {
      this.delTargetIdx.push(item.id);
    });
    this.logger.debug("items",this.delTargetIdx);

    this.deletePolicyTarget(this.delTargetIdx.join("|"),this.viewTypeTargett);
  }

  targetAddConfirm(){
    this.targetAddShow = false;
    this.logger.debug("groupList",this.selectedGroupList);
    this.logger.debug("userList",this.selectedUserList);
    this.logger.debug("deviceList",this.selectedDeviceList);

    // comapny :: url = "/mgr/policy/" + this.selectedPolicy.id + "/company";
    //    - param : company id
    // group   :: url = "/mgr/policy/" + this.selectedPolicy.id + "/group";
    //    - parm  : group id list
    // user    :: url = "/mgr/policy/" + this.selectedPolicy.id + "/user";
    //    - parm : user id list
    // device  :: url = "/mgr/policy/" + this.selectedPolicy.id + "/device";
    //    - parm : device id list
    let grouplist:number [] = [];
    let userList = [];
    let deviceList = [];
    if(this.viewTypeTargett == "group"){
      if(this.selectedGroupList&& this.selectedGroupList.length > 0){
        //let url = "/mgr/policy/" + this.selectedPolicy.id + "/group";
        this.logger.debug("그룹리스트");
        for(let group of this.selectedGroupList){
          grouplist.push(group.id);
        }
        this.addTargetList(this.selectedPolicy.id,"group",grouplist);

      }else{ this.addTargetList(this.selectedPolicy.id,"group",grouplist); }
    }else if(this.viewTypeTargett == "user"){
      if(this.selectedUserList && this.selectedUserList.length > 0){
        this.selectedUserList.forEach(item =>{
          userList.push(item.id);
          //totalSelectedType.push("U");
        });
        this.addTargetList(this.selectedPolicy.id,"user",userList);

      }else{this.addTargetList(this.selectedPolicy.id,"user",userList);}
    }else if(this.viewTypeTargett == "device"){
      if(this.selectedDeviceList && this.selectedDeviceList.length > 0){
        this.selectedDeviceList.forEach(item =>{
          deviceList.push(item.id);
        });
        this.addTargetList(this.selectedPolicy.id,"device",deviceList);
      }else{ this.addTargetList(this.selectedPolicy.id,"device",deviceList); }
    }

  }
  targetAddCancel(){
    this.targetAddShow = false;
    this.selectedGroupList = [];
    this.selectedUserList = [];
    this.selectedDeviceList = [];
    if(this.viewTypeTargett == "group") this.getPolicyTargetList(this.selectedPolicy.id,this.viewTypeTargett);
    else this.getPolicyTargetList(this.selectedPolicy.id,this.viewTypeTargett,0,400);
  }

  /*paginate(event) {
    this.pageMax = event.rows;
    if(this.selectdTargetLists.length >0)
    this.getGroupUserList(this.selectdTargetLists[0].id,event.page,this.pageMax);

  }*/

  selectDetailPolicy(policy){

    this.detailShow = true;
    this.detailName = policy.name;
    this.detailSettingValue = policy.expression;
    this.title = this.translate.instant('LANG_View_Detail');
    this.dialogWidth = "640px";
  }

  confirm(event){
    this.detailShow = false;

  }

  /*policySelected(event){
    this.logger.debug(event);
    this.selectedPolicyItem =[];
    this.selectedPolicyItem.push(event.data);
    this.logger.debug("policyItem",this.selectedPolicyItem);
    this.logger.debug("selected",this.selectedPolicyLists);
  }*/


  getSelect(item) : SelectItem[]{

    let selectItem = item.split(";");

    this.selectItem=[];
    for(let i=0;i<selectItem.length;i++){
      let select = selectItem[i].replace("&","").split(":");
      if(select.length ==2){
        let value = select[0];
        let label = this.translate.instant(select[1]);

        this.selectItem.push({label:label ,value:value});
      }
    }

    return this.selectItem;

  }

  priorityUpAndDown(policy,state){
    let originalPriority :any[]=[];
    if(this.mdmpcondList){
      this.mdmpcondList.forEach(item =>{
        originalPriority.push(item.id);
      });
    }
    let temp;
    if(state == 'down'){
      this.logger.debug(policy.id);

        for(let i=0;i<originalPriority.length;i++){

          if(originalPriority[i] == policy.id){
            if(i== originalPriority.length-1 || i==0){
              break;
            }

            temp = originalPriority[i+1];
            originalPriority[i+1] = originalPriority[i];
            originalPriority[i]= temp;

            break;

          }

        }
      this.priority = originalPriority;
      this.logger.debug("result",originalPriority.join("|"));
      this.service.updatePriority(originalPriority.join("|")).subscribe(
        value=>{if(value){this.getPolicyConditionList(this.selectedPolicy.id, 1, 10);} }
      );
    }else{
      for(let i=0;i<originalPriority.length;i++){

        if(originalPriority[i] == policy.id){
          if(i== 1 || i==0){
            break;
          }

          temp = originalPriority[i-1];
          originalPriority[i-1] = originalPriority[i];
          originalPriority[i]= temp;

          break;

        }

      }
      this.priority = originalPriority;
      this.logger.debug("result",originalPriority.join("|"));
      this.service.updatePriority(originalPriority.join("|")).subscribe(
        value=>{if(value){this.getPolicyConditionList(this.selectedPolicy.id, 1, 10);} }
      );
    }
  }


  policySave(evnet){
    this.logger.debug("정책저장");

    let control = "";
    this.policyDetailSelected.forEach(
      data => {
        control += data.id +"="+data.controlValue+"|";
      }
    );


    let items :any ={
      conid : "",
      control : "",
      flag : 'save',
      policyDesc : this.mdmPolicy.policyDesc,
      policyName : this.mdmPolicy.name

    };
    if(this.selectedCondtion){
      items.conid = this.selectedCondtion.id;
      items.control = control;

    }else{
      items.conid = "";
      items.control = "";

    }
    this.saveToDeploy(this.selectedPolicy.id,items);
    this.logger.debug("itemss",items);
  }

  policyConditionListAdd(event){
    this.logger.debug("정책 조건 설정 추가");
    if(this.selectedPolicy){
      this.policyConditionListAddShow = true;
      this.title = this.translate.instant('LANG_POLICY_conditionConfig_Add');
      this.conditonAddName = "";
      this.pConListAddVal = "time";
      this.selectedGPSList = [];

      this.beginHH = 9;
      this.beginMM = 0;
      this.endHH = 18;
      this.endMM = 0;
      //오피스앱 리스트 가져오기
      this.getOfficeAppList(this.selectedCompany.id);

      //gps 리스트 가져오기

    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }

  }
  zeroAppend(item : number){
    var te : any;
    if(item < 10){
      te = "0"+item;
      return te;
    }else {
      return item;
    }
  }

  conditionAddConfirm(){
    this.logger.debug("추가");
    var exp = "";
    let alph ="";
    let result = false;
    if(this.pConListAddVal == "time"){
      if(this.selectedHoliday.length == 0){
        alph = "N";
      } else{
        alph= "H";
      }
      exp = "Time("+alph+" "+this.zeroAppend(this.beginHH)+this.zeroAppend(this.beginMM)+"-"+this.zeroAppend(this.endHH)+this.zeroAppend(this.endMM)+")";
      result = true;
    }else if(this.pConListAddVal == "wifi"){

    }else if(this.pConListAddVal == "officeApp"){
      if(this.selectedOfficeAppList && this.selectedOfficeAppList.length >0){
        exp ="App(";
        this.selectedOfficeAppList.forEach(item => {
          exp+=item.packageName+",";
        });

        exp = exp.slice(0,-1);
        exp += ")";
        result = true;
      }else{
        alert(this.translate.instant('MESSAGE_Select_OneMore_App'));
      }

    }else if(this.pConListAddVal == "gps"){
        if(this.selectedGPSList && this.selectedGPSList.length > 0){
            exp = "GPS("
            this.selectedGPSList.forEach(item => {
               exp+=item.locationGPS+",";
            });

            exp = exp.slice(0,-1);
            exp += ")";
            result = true;
        }
    }
    if(result){
      this.logger.debug("exp",exp);
      let params = {
        name : this.conditonAddName,
        expression : exp
      }

      this.logger.debug("params",params);

      this.insertPolicyCondition(this.selectedPolicy.id,params);

      this.policyConditionListAddShow = false;
    }

  }

  conditionAddCancel(){
    this.logger.debug("취소");
    this.policyConditionListAddShow = false;
  }

  policyConditionListDel(event){
    this.logger.debug("정책 조건 설정 삭제");
    this.logger.debug("selectedCondition : ", this.selectedCondtion);
    if(this.selectedCondtion && this.selectedCondtion.name != "ANY"){
      this.deletePolicyCondition(this.selectedCondtion.id);
    }else if(this.selectedCondtion == null){
      alert(this.translate.instant('MESSAGE_Select_PolicyCondition'));
    }else if(this.selectedCondtion.name == "ANY"){
      alert(this.translate.instant('MESSAGE_ANY_Default_Not_Delete'));
    }
  }

  //--------------------------------- 정책 트리 ---------------------------------


  getPolicyOne(id:number) {
    this.service.getPolicyOne(id).subscribe(
    value => {
      this.logger.debug("policy  :", value);
      this.mdmPolicy = value;
    },
    error => {this.logger.error("-- error : " + error)}
  )
  }

  getPolicyTree(type:number) {
      this.service.getPolicyTree(type).subscribe(
      value => {
        this.logger.debug("policy Tree :", value);
        this.policyList = value;
      }, error => {this.logger.error("-- error : " + error); }
    )
  }


  onPolicySelect(event):void {
    this.logger.debug("selected node : ",event);
    /*if(event.node.parent == null){  // select company
      return;
    }*/

    let tabArr = this.targetTab.tabs;
    for(let i=0;i<tabArr.length;i++){
      if(i==0){tabArr[i].selected=true;}
      else{tabArr[i].selected=false;}
    }

    let osArr = this.osTab.tabs;
    for(let i=0;i<osArr.length;i++){
      if(i==0){osArr[i].selected=true;}
      else{osArr[i].selected=false;}
    }

    let anyArr = this.anyTab.tabs;
    for(let i=0;i<anyArr.length;i++){
      if(i==0){anyArr[i].selected=true;}
      else{anyArr[i].selected=false;}
    }

    this.selectedPolicy = event.node.data;
    this.policyDetailSelected = [];
    this.policyDetailClassList = [];

    this.selectedUserList = [];
    this.selectedDeviceList = [];
    this.selectedGroupList = [];
    this.setGroupTargetList = [];
    this.setUserTargetList = [];
    this.setDeviceTargetList = [];

    this.logger.debug("selectedPolicy",this.selectedPolicy);

    this.viewTypeTargett = "group";
    //this.getPolicyControlDefault(this.selectedPolicy.id);     //컨디션 누를때 나오는거라 여기선 안해도됨 정책항목 나오는것.   디폴트 정책항목들 전부와 선택했던것들..
    this.getPolicyOne(this.selectedPolicy.id);            //정책에대한 기본 정보

    this.getPolicyTarget(String(this.selectedPolicy.id),1,10);  //정책에 대한 적용대상 가져오는거..       옛날거 유저와 디파이스 가져오기
    //this.getPolicyControlList(this.selectedPolicy.id,1,10);  // 컨디션 누를때 나오는거라 여기선 안해도됨 정책항목만 나오는것.
    this.getPolicyConditionList(this.selectedPolicy.id, 1, 10);  //정책에 조건 설정 가져오는거
    this.getPolicyTargetList(this.selectedPolicy.id,"group");           //정책에 대한 적용대상 가져오는거...    위의 getpolicyTarget에서 그룹은 안가져와서 전체로 가져오는거 했었음...
    this.getGroupTarget(this.selectedPolicy.id);       // 정책적용대상 그룹 가져오는것.
    this.getGpsList(1, 40, '','','');

  }

  policyAdd(event){
    this.policyAddShow = true;
    this.areaTypeShow = false;
    this.title = this.translate.instant('LANG_POLICY_add');
    let temp ;
    this.policyAddForm.reset();

    this.policyAddForm.get("name").setValue("");
    this.policyAddForm.get("policyDesc").setValue("");
    this.policyAddForm.get('type').setValue(null);
    this.policyAddForm.get('areaType').setValue(0);
    /*this.service.getCompanies(0,20).subscribe(
      value => {
        this.logger.debug("company Value", value);
        temp = value.content;
        this.companyLists = [];
        this.companyLists.push({label : '-----------------------', value : null});
        if(temp && temp.length>0){
          temp.forEach(item => {
            this.companyLists.push({label : item.name, value : item.id});
          })
        }

      },
      error => { this.logger.error("-- error : ", error); }
    )*/
    this.companyLists = [];
    this.companyLists.push({label:this.selectedCompany.name,value: this.selectedCompany.id});
    this.policyAddForm.get('company').setValue(this.selectedCompany.id);
  }

  policyTypeChange(){
    let val = this.policyAddForm.get("type").value;
    if(val == 0){
      this.areaTypeShow = false;
      this.policyAddForm.get("areaType").setValue(0);
    }else if(val == 2){
      this.areaTypeShow = true;
      this.policyAddForm.get("areaType").setValue(0);
    }
    //this.logger.debug("val",this.policyAddForm.get("type").value);
  }

  policyDel(event){

    if(!this.selectedPolicy) {
      alert(this.translate.instant('MESSAGE_Select_Policy_Delete'));
      return;
    }

    if(this.selectedPolicy.name.indexOf("Default")>-1){
      alert(this.translate.instant('MESSAGE_Default_Policy_Not_Delete'));
    }else{

      if(this.selectedPolicy.id){
        this.confirmationService.confirm({
          message: this.translate.instant('MESSAGE_Want_Delete'),
          header: this.translate.instant('BUTTON_DEL'),
          icon: 'fa fa-trash',
          accept: () => {
            this.service.deletePolicy(this.selectedPolicy.id).subscribe(
              value => {
                alert(this.translate.instant('Operation_DELETE'));
                this.getNewPolicyTree(this.selectedCompany.id,0,"default");
              },
              error => { this.logger.error("-- error : ", error); }
            )
          }
        });
      }else{
        alert(this.translate.instant('MESSAGE_Select_Policy_First'));
      }

    }

  }

  onSubmit(value){
    this.logger.debug(value);
    this.service.insertPolicy(value).subscribe(
        value => {
            this.logger.debug("insertPolicy value", value);
            if(value && value.id>0){
              alert(this.translate.instant('MESSAGE_Policy_Add_Ok'));
            }else{
              alert(this.translate.instant('MESSAGE_Policy_Add_Fail'));
            }
            this.getNewPolicyTree(this.selectedCompany.id,0,"default");
        },
        error => { this.logger.error("-- error : ", error); }
    );
    this.policyAddShow = false;
  }

  policyAddCancel(){
    this.policyAddShow = false;
  }

  viewTypeTarget(event){
    if(this.selectedPolicy){
      if(event.index == 0) { this.getPolicyTargetList(this.selectedPolicy.id,"group"); this.delTargets = []; this.viewTypeTargett = "group"; this.groupShow = true;}
      else if(event.index ==1){ this.getPolicyTargetList(this.selectedPolicy.id,"user",0,400); this.delTargets = []; this.viewTypeTargett = "user"; this.groupShow = true;}
      else if(event.index ==2) { this.getPolicyTargetList(this.selectedPolicy.id,"device",0,400); this.delTargets = []; this.viewTypeTargett = "device"; this.groupShow = true;}
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
      return;
    }
  }

  groupTargetDeploy(event){
    this.logger.debug("그룹 배포");
    //this.logger.debug("getPolicyTargetLists 은?", this.getPolicyTargetLists);
    if(this.selectedPolicy){
      let groupList :any = this.getSeletingTargetItem(this.selectedGroupList);
      if(groupList.length >0 || this.getPolicyTargetLists.length>0){
        this.deployPolicyTarget(this.selectedPolicy.id,"group",groupList);
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_Group'));
      }
    }else{
        alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }


  }
  userTargetDeploy(event){
    this.logger.debug("유저 배포");
    //this.logger.debug("getPolicyTargetLists 은?", this.getPolicyTargetLists);
    if(this.selectedPolicy){
      let userList :any = this.getSeletingTargetItem(this.selectedUserList);
      if(userList.length >0 || this.getPolicyTargetLists.length>0) {
        this.deployPolicyTarget(this.selectedPolicy.id, "user", userList);
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_User'));
      }
    }else{
        alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }
  }
  deviceTargetDeploy(event){
    this.logger.debug("디바이스 배포");
    //this.logger.debug("getPolicyTargetLists 은?", this.getPolicyTargetLists);
    if(this.selectedPolicy){
      let deviceList :any = this.getSeletingTargetItem(this.selectedDeviceList);
      if(deviceList.length >0 || this.getPolicyTargetLists.length>0) {
        this.deployPolicyTarget(this.selectedPolicy.id, "device", deviceList);
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_Device'));
      }
    }else{
        alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }
  }

  getSeletingTargetItem(targets){
    let item = [];
    if(targets && targets.length > 0){
      targets.forEach(value =>{
        item.push(value.id);
      })
    }
    return item;
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;

    this.logger.debug("selectedComapny",this.selectedCompany);

    this.getNewPolicyTree(this.selectedCompany.id,0,"default");
    /*this.service.getNewPolicyTree(this.selectedCompany.id,0,"default").subscribe(value =>{
        this.policyList = [];
        let item = value;
        if(item && item.length>0){
          item.forEach(val => {
            this.policyList.push({label:val.name,data:val});
          })
        }

      },
      error =>{this.logger.debug("error",error)});*/
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  getGpsList(page:number, max:number, search:string, like:string, field:string) {
       this.service.getGpsList(page, max, search, like, field).subscribe(
            value => {
                this.control_gps_list = value.rows;
                this.logger.debug("-- control_gps_list :", value);
            },
            error => { this.logger.error("-- error : " + error);},
            ()    => {}
       )
  }

}

@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule,DropdownModule,CommonModule, RouterModule,OverlayPanelModule,ButtonModule,ReactiveFormsModule, TreeModule,InputTextModule,InputTextareaModule,FormsModule,PaginatorModule,InputSwitchModule,CheckboxModule,ExDialogModule,UserGroupCheckTreeModule,SpinnerModule,TargetGroupModule,TargetUserModule,TargetDeviceModule,ConfirmDialogModule,CompanyDropDownListModule,ListboxModule,TranslatePipeMoudle],
  exports: [PolicyConfigNewComponent],
  declarations: [PolicyConfigNewComponent],
  providers: [MamAdminService,ConfirmationService],
})
export class PolicyConfigNewModule {

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/policy/policy_config_new.ts